<template>
  <el-form
    ref="form"
    :rules="rules"
    :model="model"
    label-width="160px"
    label-position="right"
  >
    <el-form-item
      label="Nombre"
      prop="name"
    >
      <el-input
        v-model="model.name"
      />
    </el-form-item>
    <el-form-item
      label="Distribuidor"
      prop="dealerId"
    >
      <el-select
        v-model="model.dealerId"
        filterable
        remote
        placeholder="Escriba el distribuidor"
        :remote-method="onLoadDealers"
        :loading="isLoadingDealers"
      >
        <el-option
          v-for="item in dealers"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
    <el-form-item
      label="Tipo de sucursal"
      prop="type"
    >
      <el-select
        v-model="model.type"
        placeholder="Selecciona">
        <el-option
          v-for="item in dealerTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
      </el-select>
    </el-form-item>
    <el-form-item
      v-model="model.isMainBranch"
      label="¿Es sucursal matriz?"
    >
      <el-switch v-model="model.isMainBranch"/>
    </el-form-item>
    <el-form-item
      label="Código postal"
      prop="zipCode"
    >
      <el-input
        v-model="model.zipCode"
        maxlength="5"
        @input="syncAddress"
      />
    </el-form-item>
    <el-form-item
      label="Estado"
      prop="state"
      v-model="model.state"

    >
      <el-input
        disabled
        v-model="model.state"
      />
    </el-form-item>
    <el-form-item
      label="Municipio"
      prop="municipality"
    >
      <el-input
        disabled
        v-model="model.municipality"
      />
    </el-form-item>
    <el-form-item
      label="Colonia"
      prop="suburb"
    >
      <el-select
        v-model="model.suburb"
        placeholder="Selecciona">
        <el-option
          v-for="item in suburbs"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
      </el-select>
    </el-form-item>
    <el-form-item
      label="Calle"
      prop="street"
    >
      <el-input
        v-model="model.street"
      />
    </el-form-item>
    <el-form-item
      label="Número exterior"
      prop="externalNumber"
    >
      <el-input
        v-model="model.externalNumber"
      />
    </el-form-item>
    <el-form-item
      label="Número interior"
      prop="internalNumber"
    >
      <el-input
        v-model="model.internalNumber"
      />
    </el-form-item>
  </el-form>
</template>

<script>
import Branch from './branches.model'
import { mapActions, mapGetters } from 'vuex'
import http from '@/services/http.service'

export default {
  name: 'BranchesForm',
  components: {},
  props: {
    oldModel: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      model: Branch.model(),
      rules: Branch.rules,
      isLoadingDealers: false,
      timeoutInstance: null,
      suburbs: [],
      dealerTypes: [
        { label: 'A', value: 'A' },
        { label: 'B', value: 'B' },
        { label: 'C', value: 'C' },
        { label: 'D', value: 'D' },
        { label: 'E', value: 'E' }
      ]
    }
  },
  computed: {
    ...mapGetters('dealers', {
      dealers: 'items'
    }),
    ...mapGetters('regions', {
      regions: 'items'
    })
  },
  mounted () {
    this.model = Object.assign(Branch.model(), this.oldModel)
  },
  methods: {
    ...mapActions('branches', ['save', 'query']),
    ...mapActions('dealers', { queryDealers: 'query' }),
    onLoadDealers (search) {
      this.isLoadingDealers = true
      this.queryDealers({
        'filters[where][name][contains]': search,
        select: 'id,name'
      }).finally(() => {
        this.isLoadingDealers = false
      })
    },
    syncAddress () {
      window.clearTimeout(this.timeoutInstance)
      this.timeoutInstance = window.setTimeout(() => {
        this.model.state = 'Sincronizando'
        this.model.municipality = 'Sincronizando'
        this.suburbs = []
        http
          .get(process.env.API_URL + 'address/' + this.model.zipCode)
          .then(response => {
            this.model.state = response.data.state
            this.model.municipality = response.data.municipality
            for (let i = 0; i < response.data.suburbs.length; i++) {
              this.suburbs.push({
                label: response.data.suburbs[i],
                value: response.data.suburbs[i]
              })
            }
            this.model.suburb = this.suburbs[0] ? this.suburbs[0].value : null
          })
          .catch(error => {
            // console.log(error)
            this.model.state = 'Código postal no encontrado'
            this.model.municipality = 'Código postal no encontrado'
            return Promise.reject(error)
          })
      }, 500)
    },
    onSubmit () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.save(this.model)
            .then(response => {
              return this.query().then(() => {
                return this.$router.push({ name: 'branches' })
              })
            })
            .catch(error => {
              console.log(error)
              if (
                error.response &&
                error.response.data.fields &&
                error.response.data.fields[0].field === 'name' &&
                error.response.data.fields[0].validation === 'unique'
              ) {
                this.$notify.error({
                  group: 'app',
                  title: 'El nombre de la sucursal ya existe.',
                  message:
                    'El nombre de la sucursal debe ser único, intente con otro nombre.'
                })
              } else {
                this.$notify.error({
                  group: 'app',
                  title: 'Error al crear sucursal.',
                  message: 'Por favor, vuelve a intentarlo.'
                })
              }
              return Promise.reject(error)
            })
        } else {
          this.$notify({
            group: 'app',
            title: 'Verifica la forma.',
            message:
              'Por favor, revisa lo errores que se indican dentro de la forma.'
          })
          return false
        }
      })
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
</style>



// WEBPACK FOOTER //
// src/modules/branches/branches-form.vue